import { render, staticRenderFns } from "./MakeRepayment.vue?vue&type=template&id=5848180c&scoped=true&"
import script from "./MakeRepayment.vue?vue&type=script&lang=js&"
export * from "./MakeRepayment.vue?vue&type=script&lang=js&"
import style0 from "./MakeRepayment.vue?vue&type=style&index=0&id=5848180c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848180c",
  null
  
)

export default component.exports